import { render, staticRenderFns } from "./IconOval.vue?vue&type=template&id=6e172cf6&scoped=true&"
import script from "./IconOval.vue?vue&type=script&lang=js&"
export * from "./IconOval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e172cf6",
  null
  
)

export default component.exports